import { createFileRoute } from '@tanstack/react-router';

import { ScheduleUpload } from '@/features/schedule-upload/components/ScheduleUpload';

export const Route = createFileRoute('/_authenticated/upload-schedule')({
  component: UploadSchedulePage,
  beforeLoad: () => ({
    breadcrumbs: [{ title: 'Upload Schedule', href: '/upload-schedule' }],
  }),
});

function UploadSchedulePage() {
  return <ScheduleUpload />;
}
